import axios from '@/utils/axios'

// 批量创建用户权限
export const createCustomerPurview = (data) => {
  return axios.post(`/customerPurview`, data)
}
